export const categories = [
    {
      id: 1,
      img: "../Image/db.jpg",
      cat: "deutsche bank"
    },
    {
      id: 2,
      img: "../Image/Zscaler.png",
      cat: "zscaler"
    },
    {
      id: 3,
      img: "../Image/Tejas.png",
      cat: "tejas"
    },
    {
        id: 4,
        img: "../Image/Google.png",
        cat: "google"
    },
];



export const profiledata = [
    {
        id: 1,
        img: "https://media.licdn.com/dms/image/D4D03AQEmPnFZmAx1QQ/profile-displayphoto-shrink_800_800/0/1697152609159?e=1715817600&v=beta&t=-e3Jpd2cY4tZ1bWfjCVx5Z8nP0F9Qs8lElNgBM4VdCw",
        name: "Shesh Nath",
        email: "shesh6200@hmail.com",
        college: "LNCT",
        branch: "IT",
        enrollment_no: "0103IT201159",
        passing_year: "2024",
        company: "Avi Pta Nhi",
        package: "10000000000000000000",
        linkedIn: "https://www.linkedin.com/in/shesh2509/",
        instagram: "https://www.instagram.com/shesh2509/",
        twitter: "",
        interview: "Hay it me Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32.",    
    },
    {
        id: 2,
        img: "https://scontent.fbho1-3.fna.fbcdn.net/v/t39.30808-1/317748589_120302594232736_2399234322595103428_n.jpg?stp=c250.42.1154.1154a_dst-jpg_s320x320&_nc_cat=110&ccb=1-7&_nc_sid=5f2048&_nc_ohc=_zAHTAluEFkAX_U6JG5&_nc_ht=scontent.fbho1-3.fna&oh=00_AfA7KHqAuFH2Onj2QBsxNIJtZ0ap9s_MJcDMztLSgiyqMQ&oe=65F8D7BC",
        name: "ABCD",
        email: "shesh6200@hmail.com",
        college: "LNCT",
        branch: "IT",
        enrollment_no: "0103IT201159",
        passing_year: "2024",
        company: "Avi Pta Nhi",
        package: "23LPA",
        linkedIn: "",
        instagram: "",
        twitter: "",
        interview: "",    
    },
    {
        id: 3,
        img: "https://media.istockphoto.com/id/1316420668/vector/user-icon-human-person-symbol-social-profile-icon-avatar-login-sign-web-user-symbol.jpg?s=612x612&w=0&k=20&c=AhqW2ssX8EeI2IYFm6-ASQ7rfeBWfrFFV4E87SaFhJE=",
        name: "EFGH",
        email: "shesh6200@hmail.com",
        college: "LNCT",
        branch: "IT",
        enrollment_no: "0103IT201159",
        passing_year: "2024",
        company: "Avi Pta Nhi",
        package: "23LPA",
        linkedIn: "",
        instagram: "",
        twitter: "",
        interview: "",    
    },
    {
        id: 4,
        img: "https://media.istockphoto.com/id/1316420668/vector/user-icon-human-person-symbol-social-profile-icon-avatar-login-sign-web-user-symbol.jpg?s=612x612&w=0&k=20&c=AhqW2ssX8EeI2IYFm6-ASQ7rfeBWfrFFV4E87SaFhJE=",
        name: "IJKL",
        email: "shesh6200@hmail.com",
        college: "LNCT",
        branch: "IT",
        enrollment_no: "0103IT201159",
        passing_year: "2024",
        company: "Avi Pta Nhi",
        package: "23LPA",
        linkedIn: "",
        instagram: "",
        twitter: "",
        interview: "",    
    },
    {
        id: 5,
        img: "https://media.istockphoto.com/id/1316420668/vector/user-icon-human-person-symbol-social-profile-icon-avatar-login-sign-web-user-symbol.jpg?s=612x612&w=0&k=20&c=AhqW2ssX8EeI2IYFm6-ASQ7rfeBWfrFFV4E87SaFhJE=",
        name: "QWER",
        email: "shesh6200@hmail.com",
        college: "LNCT",
        branch: "IT",
        enrollment_no: "0103IT201159",
        passing_year: "2024",
        company: "Avi Pta Nhi",
        package: "23LPA",
        linkedIn: "",
        instagram: "",
        twitter: "",
        interview: "",    
    },
    {
        id: 6,
        img: "https://media.istockphoto.com/id/1316420668/vector/user-icon-human-person-symbol-social-profile-icon-avatar-login-sign-web-user-symbol.jpg?s=612x612&w=0&k=20&c=AhqW2ssX8EeI2IYFm6-ASQ7rfeBWfrFFV4E87SaFhJE=",
        name: "TYUI",
        email: "shesh6200@hmail.com",
        college: "LNCT",
        branch: "IT",
        enrollment_no: "0103IT201159",
        passing_year: "2024",
        company: "Avi Pta Nhi",
        package: "23LPA",
        linkedIn: "",
        instagram: "",
        twitter: "",
        interview: "",    
    },
    {
        id: 7,
        img: "https://media.istockphoto.com/id/1316420668/vector/user-icon-human-person-symbol-social-profile-icon-avatar-login-sign-web-user-symbol.jpg?s=612x612&w=0&k=20&c=AhqW2ssX8EeI2IYFm6-ASQ7rfeBWfrFFV4E87SaFhJE=",
        name: "BNMV",
        email: "shesh6200@hmail.com",
        college: "LNCT",
        branch: "IT",
        enrollment_no: "0103IT201159",
        passing_year: "2024",
        company: "Avi  Pta Nhi",
        package: "23LPA",
        linkedIn: "",
        instagram: "",
        twitter: "",
        interview: "",    
    },
];
